export const maxWidth = 2000;
